import { generateRandomNumber } from "../../../utils/utils";

export const createUUID = () => generateRandomNumber().toString(36).substring(2, 8);
